import React, { useState, useEffect } from 'react';

const TradingHistory = ({ userData }: { userData?: any }) => {
  const [trades, setTrades] = useState<any[]>([]);
  const storedUser = localStorage.getItem('user');
  const activeUser = userData || (storedUser ? JSON.parse(storedUser) : null);

  useEffect(() => {
    if (activeUser?.id) {
      fetch(`https://motilalalgo.com/api/admin/user-trades/${activeUser.id}`)
      // fetch(`http://localhost:10001/api/admin/user-trades/${activeUser.id}`)
        .then(res => res.json())
        .then(data => {
          if (data.success) setTrades(data.trades);
        });
    }
  }, [activeUser]);

  if (!activeUser) return null;

  const formatDate = (dateString: string) => {
    const d = new Date(dateString);
    return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}, ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
  };

  return (
    <div className="max-w-6xl mx-auto space-y-8 font-[Urbanist] px-2 md:px-0">
      
      <div>
        <h1 className="text-3xl font-black text-[#0f172a]">Trade Details</h1>
      </div>

      <div className="bg-white border border-[#f1f5f9] rounded-[24px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] overflow-hidden">
        {/* Table wrapper for mobile horizontal scrolling */}
        <div className="overflow-x-auto w-full custom-scrollbar p-6">
          <table className="w-full text-left border-collapse min-w-[1200px]">
            <thead>
              <tr className="border-b border-slate-100">
                <th className="py-4 pr-6 text-sm font-bold text-slate-800 whitespace-nowrap">S. No</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Serial No.</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Stock</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Buy Price (₹)</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Buy Qty</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Sell Price (₹)</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Sell Qty</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">My Holding</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Derivative</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Profit/Loss</th>
                <th className="py-4 px-6 text-sm font-bold text-slate-800 whitespace-nowrap">Created At</th>
                <th className="py-4 pl-6 text-sm font-bold text-slate-800 whitespace-nowrap">Updated At</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {trades.length === 0 ? (
                <tr><td colSpan={12} className="text-center py-6 text-slate-500">No trades found.</td></tr>
              ) : (
                trades.map((trade, idx) => (
                  <tr key={trade.id} className="hover:bg-slate-50 transition-colors">
                    <td className="py-4 pr-6 text-sm text-slate-600">{idx + 1}</td>
                    <td className="py-4 px-6 text-sm text-slate-600 font-medium">{trade.serial_no || '-'}</td>
                    <td className="py-4 px-6 text-sm text-slate-800 font-bold">{trade.stock_name}</td>
                    <td className="py-4 px-6 text-sm text-slate-600">{trade.buy_price}</td>
                    <td className="py-4 px-6 text-sm text-slate-600">{trade.buy_qty}</td>
                    <td className="py-4 px-6 text-sm text-slate-600">{trade.sell_price}</td>
                    <td className="py-4 px-6 text-sm text-slate-600">{trade.sell_qty}</td>
                    <td className="py-4 px-6 text-sm text-slate-600">{trade.my_holding}</td>
                    <td className="py-4 px-6 text-sm text-slate-600">{trade.derivative}</td>
                    <td className={`py-4 px-6 text-sm font-bold ${parseFloat(trade.profit_loss) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                      {parseFloat(trade.profit_loss) > 0 ? '+' : ''}₹{trade.profit_loss}
                    </td>
                    <td className="py-4 px-6 text-sm text-slate-600 whitespace-nowrap">{formatDate(trade.created_at)}</td>
                    <td className="py-4 pl-6 text-sm text-slate-600 whitespace-nowrap">{formatDate(trade.updated_at)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Basic Pagination layout (Static for now, implement logic as needed) */}
        <div className="flex justify-between items-center p-6 bg-slate-50/50 border-t border-slate-100">
          <button className="px-4 py-2 border border-slate-200 rounded-lg text-sm font-bold text-slate-500 hover:bg-slate-100 transition-colors">Previous</button>
          <span className="text-sm text-slate-500 font-medium">Page 1 of 1</span>
          <button className="px-4 py-2 border border-slate-200 rounded-lg text-sm font-bold text-slate-800 bg-white hover:bg-slate-50 transition-colors">Next</button>
        </div>
      </div>

    </div>
  );
};

export default TradingHistory;